import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './index.css';

const LacyVideoSection = () => {
  const [activeStory, setActiveStory] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [storiesData, setStoriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Fetch data from S3
  useEffect(() => {
    const fetchStories = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_CDN_LINK}jsons/LacyVideo.json`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.status}`);
        }
        
        const data = await response.json();
        setStoriesData(data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching video data:", err);
        setError(err.message);
        setLoading(false);
      }
    };
    
    fetchStories();
  }, []);
  
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  
  const handleVideoPlay = (slideIndex) => {
    setActiveStory(slideIndex);
    setIsPlaying(true);
  };
  
  // Extract the name from the title (assuming format "A X for Name")
  const extractName = (title) => {
    const parts = title.split(' for ');
    return parts.length > 1 ? parts[1] : '';
  };
  
  // Check if we have multiple stories
  const hasMultipleStories = storiesData.length > 1;

  // Render a single video without carousel if only one story
  const renderSingleVideo = () => {
    const story = storiesData[0];
    return (
      <div className="story-card">
        <div className="story-video-container">
          {!isPlaying ? (
            <>
              <img 
                src={story.thumbnail} 
                alt={story.alt} 
                className="story-thumbnail" 
                onClick={() => handleVideoPlay(0)}
              />
              <div className="play-button-overlay" onClick={() => handleVideoPlay(0)}>
                <img 
                  src="https://stagingresources.swmc.com/swmc-images/play-button.webp" 
                  alt="Play" 
                  className="play-button" 
                />
              </div>
            </>
          ) : (
            <iframe
              title={story.title}
              width="100%"
              height="100%"
              src={`${story.videoUrl}?autoplay=1&playsinline=0&controls=1&showinfo=1&rel=0`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </div>
    );
  };

  // Render carousel with multiple videos  
  const renderCarousel = () => {
    return (
      <Carousel
        responsive={responsive}
        infinite={false}
        autoPlay={false}
        showDots={true}
        arrows={false}
        renderDotsOutside={true}
        dotListClass="dots-container"
        afterChange={(nextSlide) => {
          setActiveStory(nextSlide);
          setIsPlaying(false);
        }}
      >
        {storiesData.map((story, index) => (
          <div key={story.id} className="story-card">
            <div className="story-video-container">
              {!isPlaying || activeStory !== index ? (
                <>
                  <img 
                    src={story.thumbnail} 
                    alt={story.alt} 
                    className="story-thumbnail" 
                    onClick={() => handleVideoPlay(index)}
                  />
                  <div className="play-button-overlay" onClick={() => handleVideoPlay(index)}>
                    <img 
                      src="https://stagingresources.swmc.com/swmc-images/play-button.webp" 
                      alt={story.alt}
                      className="play-button"
                      title={story.title}
                    />
                  </div>
                </>
              ) : (
                <iframe
                  title={story.title}
                  width="100%"
                  height="100%"
                  src={`${story.videoUrl}?autoplay=1&playsinline=0&controls=1&showinfo=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        ))}
      </Carousel>
    );
  };
  
  return (
    <div className="success-stories-section">
      <Container>
        <Row>
          <Col sm={12} lg={5} className="success-stories-content">
            <div className="blue-side-bar mb-0"></div>
            <div className="white-side-bar"></div>
            <div className="content-wrapper-desktop">
              <h1 className="success-title">Success <br/> <span>Stories</span></h1>
              <p className="success-subtitle">
                Real People, Real Results - See How <a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>AngelAi</a> Changes Lives.
              </p>
            </div>
            <div className="content-wrapper-mobile">
              <h1 className="success-title mb-0">
                <span className="success-blue">Success</span> Stories
              </h1>
              <img className="border-img" src='https://stagingresources.swmc.com/swmc-images/lacy-mobile-border.webp' alt="border" />
              <p className="success-subtitle">
                Real People, Real Results - See How AngelAi Changes Lives.
              </p>
            </div>
          </Col>
          <Col sm={12} lg={7} className="lacy-carousel-container">
            {loading ? (
              <div className="loading-spinner">Loading videos...</div>
            ) : error ? (
              <div className="error-message">Error loading videos: {error}</div>
            ) : (
              hasMultipleStories ? renderCarousel() : renderSingleVideo()
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LacyVideoSection;